import Breadcrumbs from 'components/layout/breadcrumbs/breadcrumbs';
import Image from 'components/shared/image';
import RichText from 'components/shared/richtext';
import SiteLink from 'components/shared/sitelink';
import Blog from 'components/sections/blog/blog';
import styles from './collaborator.module.scss';

const PageCollaborator = ({ data, locale, resources }) => {
  const { breadcrumbs, title, subtitle, avatar, description, socials, articles } = data;

  const blogData = {
    categories: [],
    allTopics: 'All Topics',
    blogArticles: articles,
  };

  return (
    <section className={styles.pageContainer}>
      {breadcrumbs && <Breadcrumbs data={breadcrumbs} locale={locale} />}
      <div className={styles.collaboratorInfo}>
        <h1>{title}</h1>
        <h2>{subtitle}</h2>
        <div className={styles.avatar}>
          <Image src={avatar} />
        </div>
        <RichText text={description.json} className={styles.collaboratorDescription} />
        <div className={styles.socialLinks}>
          {socials.map(social => (
            <SiteLink className={styles.socialIcon} external={`${social?.link}`}>
              <Image src={social?.socialIcon} layout="responsive" loading="lazy" />
            </SiteLink>
          ))}
        </div>
      </div>

      <Blog data={blogData} locale={locale} resources={resources} />
    </section>
  );
};

export default PageCollaborator;
